import React from 'react';
import './ProjectCard.css';

export default function ProjectCard(props) {
    return (
        <div className="project-card">
            <span className="hightlighted-text">{props.name}</span>
            <textarea className="project-card-description regular-text" defaultValue={props.description}></textarea>
            <span className="project-card-languages-text">Languages/Tools: <br></br> {props.languages}</span>
            <div className="project-card-anchors-container">
                <a href={props.projectLink} rel="noreferrer noopener" target="_blank" className="project-card-anchor">Open project</a>
                <a href={props.codeLink} rel="noreferrer noopener" target="_blank" className="project-card-anchor">Open code</a>
            </div>
        </div>
    )
}
